import Vue from 'vue';
import VueI18n from 'vue-i18n';
import pt from 'vee-validate/dist/locale/pt_PT.json';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);

  const messages = {};

  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });

  messages['pt-PT'].validation = pt.messages;

  return messages;
}

const numberFormats = {
  'pt-PT': {
    currency: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol',
    },
    decimal: {
      style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2,
    },
  },
};

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'pt-PT',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'pt-PT',
  messages: loadLocaleMessages(),
  numberFormats,
});
